import React from 'react';
import styles from '../assets/styles/ProsSection.module.css';
import Pro from './Pro';
import { BsHourglassSplit } from "react-icons/bs";
import { VscLaw } from "react-icons/vsc";
import { LuHandHeart } from "react-icons/lu";
import imgPullupBanner from '../assets/images/pullupbanner.jpg';


const ProsSection = () => {
  return (
    <div>
      <div className={styles.prosSection}>
        <div className={styles.textContainer}>
          <div className={styles.title}>Starnet Legal is here for you.</div>
          <div className={styles.description}>
            We pride ourselves on providing the best legal services to our clients. Here's why you should choose Starnet Legal:
          </div>
        </div>
        <div className={styles.prosContainer}>
          <Pro icon={<BsHourglassSplit />} header="Extensive Experience" description="Our lawyers draw on first-hand knowledge from hundreds of career cases, so you can feel confident knowing we've seen a case like yours before." />
          <Pro icon={<VscLaw />} header="Reliable Service" description="We understand that legal matters can be stressful. We are here to help you navigate the legal system and provide you with the best possible outcome." />
          <Pro icon={<LuHandHeart />} header="Compassionate Approach" description="We understand that every case is unique and we take the time to understand your situation. We are here to help you through the difficulties you're facing." />
        </div>
        <div className={styles.imgContainer}>
          <img src={imgPullupBanner} alt="Legal Team" className={styles.img} />
        </div>
      </div>
    </div>
  );
};

export default ProsSection;